export { AutoSizeText } from "#auto-size-text";
